import React, { Component } from 'react';
import { Header, TopBar , Footer,  Loader } from '../layouts/general';
import { Link } from "react-router-dom";

class Appoinment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headers: [
                {
                    id: 1,
                    names: 'Blog',
                }
            ],
            titleheading: [
                {
                    id: '1',
                    title: 'Get An Appoinment'
                }
            ],
            breadcrumbs: [
                {
                    id: 1,
                    title: 'Home',
                    classicon: 'fa fa-angle-right',
                    aria: 'true'
                },
                {
                    id: 2,
                    title: 'Appointment',
                    classicon: '',
                    aria: 'true'
                }
            ],
            contactinfo: [
                {
                    id: '1',
                    title: 'Address',
                    info:'418 Hanlan Rd, Unit 4, Bulding A,  Vaughan, ON L4L 4Z1'
                },
                {
                    id: '2',
                    title: 'Phone number',
                    info:'Call us: 416-763-1354'
                },
                {
                    id: '3',
                    title: 'E-mail address',
                    info:'info@fandsconsulting.ca'
                }
            ]
        }
    }
    render() {
        return (
            <div className="bg-body">
                <div className="boxed">
                    <TopBar />
                    {
                        this.state.headers.map(data => (
                            <Header data={data} key={data.id}/>
                        ))
                    }

                    <div className="page-title">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="page-title-heading">
                                        {
                                            this.state.titleheading.map(data =>(
                                                <h1 key={data.id} className="h1-title">{data.title}</h1>
                                            ))
                                        }       
                                    </div>
                                    <ul className="breadcrumbs">
                                        {
                                            this.state.breadcrumbs.map(data =>(
                                                <li key={data.id} ><Link to="#" title="">{data.title}<i className={data.classicon} aria-hidden={data.aria}></i></Link></li>
                                            ))
                                        }
                                    </ul>
                                    <div className="clearfix"></div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <section className="flat-row">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div>
                                    <iframe src="https://calendly.com/fandscons/15min" className="no-scroll-iframe" style={{width:'100%',height:"100vh"}}></iframe>
                                    </div>
                                </div> 

                            </div>
                        </div>
			        </section>

	       
                    <Footer />
                </div>
            </div>
        );
    }
}

export default Appoinment;
